<div>
    <div style="margin-left: 80%; margin-bottom: 2%;">

        <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger"
            (click)="exportexcel('Address')" style="margin-top: 2%;">
            Export
        </button>


        <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none;"
            mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
            Print
        </button>

        <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button
            color="primary">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>

    <div class="container">
        <table class="table table-bordered" id="print-section">
            <thead>
                <tr>
                    <div
                        style="display: grid; grid-template-columns: 1fr 1fr 1fr; width: 100%; text-align: center; font-weight: bold; justify-content: center;">
                        <span style="grid-column: span 3; text-align: center; font-size: xx-large;color: black !important;">प्रसिद्धी
                            पत्रक</span>
                    </div>



                    <div style="
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-weight: bold;
    flex-wrap: wrap;
    gap: 10px;
    margin-top : 20px;
    color: black !important;
">
                        <span style="text-align: left; padding-left: 15px; color: black !important;">अंक नाव :- {{ issuenamenew }}</span>
                        <span style="text-align: left; font-size: small;color: black !important;">अंक दिनांक :- {{ issuedatepp | date :
                            'dd-MM-yyyy' }}</span>
                        <span style="text-align: left; padding-left: 15px;color: black !important;">प्रतिनिधी नाव :- {{ rep_name }}</span>
                        <span style="text-align: right; padding-right: 5%;color: black !important;">दिनांक :- {{ currentDate | date:
                            'dd-MM-yyyy' }}</span>
                    </div>

                </tr>
            </thead>
            <hr>
            <tbody>
                <div class="row" style="display: flex; flex-wrap: wrap; margin-left: 25px;">
                    <!-- Loop through all items, but limit 3 per row -->
                    <ng-container *ngFor="let advtGroup of Address; let i = index">
                        <div *ngFor="let data2 of advtGroup" class="col"
                            style="flex: 0 0 33.33%; padding: 10px; box-sizing: border-box; page-break-inside: avoid;color: black !important;">
                            <b style="font-size: 20px; font-weight: bold;color: black !important;">{{ data2.name }}</b> <br>
                            <span style="font-size: 18px;color: black !important;">{{ data2.address }}</span> <br>
                            <span style="font-size: 18px;color: black !important;">{{ data2.taluka }}</span> <br>
                            <span style="font-size: 18px;color: black !important;">{{ data2.district }}-{{ data2.pincode }} {{ data2.state
                                }}</span> <br>
                            <b style="font-size: 18px;color: black !important;"> मो.क्र.{{ data2.mobile }}</b>
                        </div>
                    </ng-container>
                </div>
            </tbody>
        </table>
    </div>
</div>